import React from "react";
import { Card, Button } from "@/components/ui";
import { ShieldCheck } from "lucide-react";

export function ActiveSubscriptionCard({ status, onCancel }) {
  const renewLine = status.trial_end
    ? `Trial ends ${new Date(status.trial_end).toLocaleDateString()}`
    : status.current_period_end
      ? `Renews ${new Date(status.current_period_end).toLocaleDateString()}`
      : "";
  return (
    <Card className="mb-5 bg-mint-tint border-mint-dark" data-testid="billing-active">
      <div className="flex items-center gap-3">
        <ShieldCheck className="w-6 h-6 text-mint-dark" />
        <div className="flex-1">
          <div className="font-semibold text-ink capitalize">{status.plan_id || "Subscription"} · {status.status}</div>
          <div className="text-sm text-subtle">{renewLine} · {status.mode} mode</div>
        </div>
        <Button variant="secondary" data-testid="cancel-subscription" onClick={onCancel}>Cancel</Button>
      </div>
    </Card>
  );
}
